import { Meta } from "@/shared/components";
import { Languages } from "@/admin/features/languages";

export function LanguagesPage() {
  return (
    <>
      <Meta title="Языки" />
      <Languages />
    </>
  );
}
